export default "__VITE_ASSET__I6E4OEGO__"